const maxDelayMs = 30 * 1000

export function backoff(currentMs: number): number {
  if (currentMs <= 0) {
    return 2000
  }

  currentMs *= 2

  if (currentMs > maxDelayMs) {
    currentMs = maxDelayMs
  }

  return currentMs
}
